import { render, staticRenderFns } from "./ForwardComponent.vue?vue&type=template&id=0e222fb7"
import script from "./ForwardComponent.js?vue&type=script&lang=js&external"
export * from "./ForwardComponent.js?vue&type=script&lang=js&external"
import style0 from "./ForwardComponent.vue?vue&type=style&index=0&id=0e222fb7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports